// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`YouTubeImage test Match con el snapshot 1`] = `
<a target="_blank" href="https://www.youtube.com/bbva_argentina"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="26" viewBox="0 0 26 26">
        <defs>
            <path id="a-youtube" d="M1 13C1 6.373 6.373 1 13 1s12 5.373 12 12-5.373 12-12 12S1 19.627 1 13zm19.716.538v-1.163c0-1.24-.2-2.506-.2-2.506s-.197-1.082-.656-1.547c-.583-.61-1.236-.666-1.536-.702-2.144-.155-5.362-.26-5.362-.26h-.006s-3.19.105-5.334.26c-.3.036-.925.143-1.509.754-.459.465-.554 1.52-.554 1.52s-.043 1.241-.043 2.481v1.163c0 1.24.044 2.48.044 2.48s.04 1.057.5 1.522c.583.61 1.35.59 1.691.655 1.226.118 5.214.154 5.214.154s3.226-.005 5.371-.16c.3-.036.965-.039 1.547-.65.46-.464.633-1.52.633-1.52s.2-1.24.2-2.48zm-9.2 1.41V10.64l4.141 2.16-4.14 2.146z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <path d="M0 0h26v26H0z"></path>
            <mask id="b-youtube" fill="#5BBEFF">
                <use xlink:href="#a-youtube"></use>
            </mask>
            <use fill="#5BBEFF" xlink:href="#a-youtube" class="hover--icon"></use>
            <g fill="#5BBEFF" mask="url(#b-youtube)">
                <path d="M0 0h26v26H0z" class="hover--icon"></path>
            </g>
        </g>
    </svg></a>
`;
